import React from 'react'
import { motion } from 'framer-motion'

/**
 * Background Effects Component
 * 
 * @description Animated gradient orbs for visual enhancement
 * @accessibility Marked as decorative (pointer-events-none, aria-hidden)
 * @performance Uses CSS transforms and will-change for optimized animations
 */
const BackgroundEffects = () => {
  return (
    <div 
      className="fixed inset-0 overflow-hidden pointer-events-none" 
      aria-hidden="true"
      role="presentation"
    >
      {/* Purple-Pink gradient orb - Top Left */}
      <motion.div
        animate={{
          x: [0, 100, 0],
          y: [0, -100, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear"
        }}
        className="absolute -top-40 -left-40 w-80 h-80 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 dark:opacity-10"
        style={{ willChange: 'transform' }}
      />
      
      {/* Cyan-Blue gradient orb - Bottom Right */}
      <motion.div
        animate={{
          x: [0, -100, 0],
          y: [0, 100, 0],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "linear"
        }}
        className="absolute -bottom-40 -right-40 w-80 h-80 bg-gradient-to-r from-cyan-400 to-blue-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 dark:opacity-10"
        style={{ willChange: 'transform' }}
      />
      
      {/* Yellow-Orange gradient orb - Center */}
      <motion.div
        animate={{
          x: [0, 50, 0],
          y: [0, -50, 0],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "linear"
        }}
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full mix-blend-multiply filter blur-xl opacity-10 dark:opacity-5"
        style={{ willChange: 'transform' }}
      />
    </div>
  )
}

export default BackgroundEffects